/**
 * A column header. Sortable only when the server's sort vocabulary lists the
 * column's key; the button names the order it will apply next, and the
 * header carries aria-sort for the order in force.
 */
import React from 'react';

export interface SortHeadProps {
  label: string;
  col?: string | null;
  sort: string | null;
  dir: 'asc' | 'desc';
  sorts: string[];
  onSort: (col: string, dir: 'asc' | 'desc') => void;
  help?: string;
  className?: string;
  scope?: 'col';
}

export default function SortHead({ label, col, sort, dir, sorts, onSort, help, className }: SortHeadProps) {
  if (!col || !sorts.includes(col)) return <th scope="col" className={className} title={help}>{label}</th>;
  const on = sort === col;
  const next: 'asc' | 'desc' = on && dir === 'asc' ? 'desc' : 'asc';
  return (
    <th scope="col" className={className} title={help} aria-sort={on ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
      <button type="button" className="board-sort" onClick={() => onSort(col, next)}>
        {label}
        <span className="board-sort__mark" aria-hidden="true">{on ? (dir === 'asc' ? '▲' : '▼') : '↕'}</span>
        <span className="board-sr">{on ? `, sorted ${dir === 'asc' ? 'ascending' : 'descending'}; activate to sort ${next === 'asc' ? 'ascending' : 'descending'}` : ', activate to sort'}</span>
      </button>
    </th>
  );
}
